export type FaceClusterSpec<T> = {
    kind: 'plain' | 'single' | 'cluster';
    faces: T[];
    overflow: number;
};

// How an option's people render: nobody (image or initials), one face, or an overlapping cluster.
export const faceCluster = <T>(photos: T[], max = 4): FaceClusterSpec<T> => {
    if (photos.length === 0) return {kind: 'plain', faces: [], overflow: 0};
    if (photos.length === 1) return {kind: 'single', faces: photos, overflow: 0};
    return {
        kind: 'cluster',
        faces: photos.slice(0, max),
        overflow: Math.max(0, photos.length - max),
    };
};

// Face size in a cluster: four fifths of `size`, shrunk so the whole cluster fits `maxWidth`.
// The width maths mirrors the .sd-cluster overlaps in ballot.css.
export const clusterFaceSize = <T>(
    size: number,
    spec: FaceClusterSpec<T>,
    maxWidth = Number.POSITIVE_INFINITY,
): number => {
    const span = 0.32 + 0.68 * spec.faces.length + (spec.overflow > 0 ? 0.44 : 0);
    return Math.floor(Math.min(size * 0.8, maxWidth / span));
};
